<h5 class="text-primary mb-3">Temperature</h5>
@if (temperature()) {
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Code</th>
        <th colspan="2">{{ temperature().Code }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Actual</td>
        <td [@pulse]="temperature()?.Actual">{{ temperature()?.Actual }}</td>
      </tr>
      <tr>
        <td>Configured</td>
        <td [@pulse]="temperature()?.Configured">{{ temperature()?.Configured }}</td>
      </tr>
      <tr>
        <td>Scale</td>
        <td [@pulse]="temperature()?.Scale">{{ temperature()?.Scale === 'C' ? '&#x2103;' : '&#x2109;' }}</td>
      </tr>
      <tr>
        <td>Zone</td>
        <td [@pulse]="temperature()?.Zone">{{ temperature()?.Zone }}</td>
      </tr>
    </tbody>
  </table>
} @else {
  There is no known temperature for this room.
}